import { isEqual } from 'lodash';

import type { CustomRoleTaxonomySelection } from '@revelio/data-access';

import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type SingleValueFilter } from '../types/filters';

export const roleTaxonomyDefinition: FilterDefinition<
  SingleValueFilter<CustomRoleTaxonomySelection>
> = {
  id: FilterId.ROLE_TAXONOMY,
  name: 'Role Taxonomy',
  value: { default: true },
  type: FilterType.VALUE,
  isVisible: false,
  isActive: true,
};

export const roleTaxonomyHandler: FilterHandler<
  SingleValueFilter<CustomRoleTaxonomySelection>
> = {
  isActive(currentFilterState: SingleValueFilter<CustomRoleTaxonomySelection>) {
    return (
      currentFilterState.value !== null &&
      currentFilterState.value !== undefined
    );
  },
  isDefault(
    currentFilterState: SingleValueFilter<CustomRoleTaxonomySelection>,
    definition: FilterDefinition<SingleValueFilter<CustomRoleTaxonomySelection>>
  ) {
    return isEqual(currentFilterState.value, definition.value);
  },
  getEffectiveFilter(
    currentFilterState: SingleValueFilter<CustomRoleTaxonomySelection>
  ) {
    return { ...currentFilterState };
  },
};
